module.exports = __webpack_public_path__ + "img/water_banner.4fa51690.png";